import { IDeleteIndicadoresUseCase } from "../../../presentation/useCases/delete/delete_indicadores_servicos_use_case";
import { IQualidadeRepository } from "../../repositories/qualidade_repository";

// DeleteIndicadoresUseCase


export class DeleteIndicadoresUseCase implements IDeleteIndicadoresUseCase {
  constructor(private readonly repository: IQualidadeRepository) {}

  async deleteIndicadores( IdIndicador: number): Promise<void> {
    
    await this.repository.deleteIndicadores( IdIndicador );
  }
}
